import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHeight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.25 14.75 12 17.25l-2.25-2.5M14.25 9.25 12 6.75l-2.25 2.5M19.25 4.75H4.75M19.25 19.25H4.75"
    />
  </svg>
);
export default SvgHeight;
